import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import ServicesPage from './ServicesPage';
import PortfolioPage from './PortfolioPage';
import AboutPage from './AboutPage';
import BlogPage from './BlogPage';
import { Navbar } from './Home';
import Footer from './Footer';

const AppRoute = () => {
    return (
        <Router>
            <Navbar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/portfolio" element={<PortfolioPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/blog" element={<BlogPage />} />
            </Routes>
            <Footer />
        </Router>
    );
};

export default AppRoute;